import React from "react";

import { Strain } from "custom-types/Strain";

import Image from "components/Image";

type Props = {
  strain: Strain;
  showSvg?: boolean;
};

// Copied from FEC as it wasn't exported
const LeaflyNug: React.FC<Props> = ({ strain }) => {
  const image = (strain: Strain) => {
    return (
      <>
        <div className="absolute bottom-0 top-0" data-testid="NugImage">
          <Image
            alt="Nug Image"
            sizes={[75]}
            src={(strain.nugImage || strain.stockNugImage) as string}
          />
        </div>
      </>
    );
  };

  return (
    <div
      style={{
        flex: "none",
        height: "85px",
        position: "relative",
        width: "80px",
      }}
    >
      {image(strain)}
    </div>
  );
};

export default LeaflyNug;
